import { useLayout } from 'modules/layout/hooks/useLayout';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { disconnect } from '../../../account/store/actions/disconnect';
import { useHistory } from 'react-router-dom';

export function useWalletDropdown() {
  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { toggleNav, mobileNavShowed } = useLayout();
  const history = useHistory();

  const handleClose = useCallback(() => {
    if (isOpen) {
      setOpen(false);
    }

    if (mobileNavShowed) {
      toggleNav(false);
    }
  }, [isOpen, mobileNavShowed, toggleNav]);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleDisconnect = useCallback(() => {
    dispatch(disconnect());
    setOpen(false);
    history.push('/');
  }, [dispatch, history]);

  return {
    isOpened: isOpen,
    handleDisconnect,
    handleClose,
    handleOpen,
  };
}
